import React from 'react'
import IssuerList from '../IssuerList'
import Page from '../../Page'

export default function PageIssuers () {
  return (
    <Page title='myAMC.ch - Issuers'>
      <div className='header-bg'>
        <header id='topnav2'>
          <div className='container-fluid'>
            <div className='row align-items-center '>
              <div className='col-md-8'>
                <h6><i className='dripicons-trophy mr-2' />Issuers</h6>
                <p>Browse through our sponsor issuers</p>
              </div>
            </div>
          </div>
        </header>
      </div>

      <div className='wrapper'>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-12'>
              <div className='card'>
                <div className='card-body'>
                  <IssuerList />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Page>
  )
}
